'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import { toast } from 'sonner';

// Backend integration point: replace with /api/users/:id/alerts
const alertsData = [
  { id: 'alert-001', name: 'Dubai Marina 2BR', criteria: 'Dubai Marina • 2 Beds • Max AED 3M', matches: 8, active: true },
  { id: 'alert-002', name: 'Palm Jumeirah Villas', criteria: 'Palm Jumeirah • Villa • 5-7 Beds', matches: 3, active: true },
  { id: 'alert-003', name: 'Saadiyat Beachfront', criteria: 'Saadiyat Island • Any type • Max AED 20M', matches: 14, active: false },
];

export default function PropertyAlerts() {
  const [alerts, setAlerts] = useState(alertsData);

  const toggleAlert = (id: string) => {
    setAlerts(prev => prev.map(a => a.id === id ? { ...a, active: !a.active } : a));
    const alert = alerts.find(a => a.id === id);
    toast.success(`Alert "${alert?.name}" ${alert?.active ? 'paused' : 'activated'}`);
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-5 shadow-card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-foreground text-base">Property Alerts</h3>
        <button className="text-primary text-xs font-semibold hover:underline flex items-center gap-1">
          <Icon name="PlusIcon" size={13} />
          New Alert
        </button>
      </div>

      <div className="space-y-3">
        {alerts.map((alert) => (
          <div key={alert.id} className={`p-3 rounded-xl border transition-all ${alert.active ? 'border-primary/20 bg-primary/5' : 'border-border bg-muted/30'}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-foreground text-sm">{alert.name}</div>
                <div className="text-muted-foreground text-xs mt-0.5 line-clamp-1">{alert.criteria}</div>
                <div className={`text-xs font-semibold mt-1 ${alert.active ? 'text-primary' : 'text-muted-foreground'}`}>
                  {alert.matches} new matches
                </div>
              </div>
              <div
                onClick={() => toggleAlert(alert.id)}
                className={`w-9 h-5 rounded-full transition-all duration-200 relative cursor-pointer flex-shrink-0 mt-0.5 ${alert.active ? 'bg-primary' : 'bg-muted border border-border'}`}
              >
                <div className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-all duration-200 ${alert.active ? 'left-4' : 'left-0.5'}`} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}